import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import Loader from '@/components/Loader'
import Upload from '@/components/Upload'
import Psychometrie from '@/components/Psychometrie'
import SetRT from '@/components/SetRT'
import HorsUnion from '@/components/HorsUnion'
import Merci from '@/components/Merci'
import MerciRappel from '@/components/MerciRappel'
import VueTheMask from 'vue-the-mask'


Vue.component('loader', Loader)
Vue.component('upload', Upload)
Vue.component('psychometrie', Psychometrie)
Vue.component('set-rt', SetRT)
Vue.component('merci', Merci)
Vue.component('horsunion', HorsUnion)
Vue.component('mercirappel', MerciRappel)

Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.config.productionTip = false

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons'
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons'
import { faArrowCircleRight } from '@fortawesome/free-solid-svg-icons'
import { faMousePointer } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faCoffee)
library.add(faQuoteLeft)
library.add(faQuoteRight)
library.add(faCalendarCheck)
library.add(faFileUpload)
library.add(faArrowCircleRight)
library.add(faMousePointer)

Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
